import { createBrowserRouter } from 'react-router';
import { Layout } from './layout';
import { DashboardPage } from '@/pages/dashboard';
import { ClaimrPage } from '@/pages/claimr';
import { StakingPage } from '@/pages/staking';
import { IndexPoolPage } from '@/pages/index-pool';
import { DistributionPage } from '@/pages/distribution';
import { GnetDistributionPage } from '@/pages/gnet-distribution';
import { SettingsPage } from '@/pages/settings';
import { ConnectPage } from '@/pages/connect';
import { ApiDocsPage } from '@/pages/api-docs';

export const router = createBrowserRouter([
  {
    path: '/connect',
    element: <ConnectPage />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'claimr', element: <ClaimrPage /> },
      { path: 'distribution', element: <DistributionPage /> },
      { path: 'gnet-vesting', element: <GnetDistributionPage /> },
      { path: 'staking', element: <StakingPage /> },
      { path: 'index-pool', element: <IndexPoolPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'api-docs', element: <ApiDocsPage /> },
    ],
  },
]);
